<template>
  <span class="tour_tur">
    <el-dialog
        :title="dialogCur.title"
        :visible.sync="usageConditionsVisible">
      <div v-html="dialogCur.markup"/>
      <span slot="footer" class="dialog-footer">
        <button class="dialog-close-btn" @click="usageConditionsVisible = false">
          Закрыть</button>
      </span>
    </el-dialog>

    <div
      class="tur_win"
      v-show="isVisible"
      :class="popupClass">
      <div
        class="tur_corner"
        :class="{ [cornerClass]: true }"
        :style="cornerStyle">
      </div>
      <button @click="stopTour" class="tur_close">
        <i class="el-icon-close"></i></button>
      <div class="tur_title">
        <span class="tur_title-step">{{ curStep + 1 }} / {{ steps.length }}</span>
        {{ title }}
      </div>
      <div class="tur_text" v-html="text"></div>
      <div class="tur_nav">
        <button
            class="tur_nav-btn"
            @click="gotoStep(--curStep)"
            v-if="curStep > 0">
          Назад
        </button>
        <button
            class="tur_nav-btn"
            @click="gotoStep(++curStep)"
            v-if="curStep < steps.length - 1">
          Вперед
        </button>
        <button
            class="tur_nav-btn tur_nav-btn-xl"
            @click="$router.push({ path: '/user/register' })"
            v-if="curStep === steps.length - 1">
          Зарегистрироваться
        </button>
      </div>
    </div>
  </span>
</template>

<script>
/* eslint-disable default-case */
import J from 'jquery';
import { TweenMax, Power1 } from 'gsap/TweenMax';
import licenses from '@/data/licenses';

export default {

  data() {
    return {
      isVisible: false,
      curStep: 0,
      licenses,
      usageConditionsVisible: false,
      dialogCur: {
        title: '',
        markup: '',
      },
      steps: [
        {
          path: '/',
          mobileAnchor: '1270:.ntp_logo_lgo',
          anchor: '.fwp_site-title',
          pos: 'bottom',
          offsetY: 0,
          title: 'Добро пожаловать на платформу IPUniversity!',
          text: '<p>Платформа на основе технологии распределенного реестра создает уникальные возможности для быстрого закрепления авторских прав, хранения и оборота объектов авторского права.</p>',
        },
        {
          path: '/',
          anchor: '.hos_stage',
          pos: 'middle-top',
          offsetY: -100,
          title: 'Для кого предназначена платформа?',
          text: '<p>Если вы – исследователь, преподаватель, аспирант одного из вузов-участников IPUniversity – вы можете мгновенно регистрировать в системе цифровые объекты авторского права, просматривать их статусы и рейтинги, анализировать актуальные тенденции и направления.</p>',
        },
        {
          path: '/object/IPC-RU.IPU.AD.2018-087EJD7J.1',
          offsetY: 0,
          anchor: '#of_object-id',
          pos: 'bottom',
          title: 'Идентификатор объекта (Intellectual Property Code, IPC)',
          text: '<p>После завершения процесса депонирования (передачи объекта на хранение в распределенном реестре) ему будет присвоен IPC – уникальный код, который удостоверит ваше право авторства. Вы получите свидетельство, содержащее доказательство принадлежности вам IPC, и штамп времени.</p>',
        },
        {
          path: '/object/IPC-RU.IPU.AD.2018-087EJD7J.1',
          offsetY: 0,
          mobileAnchor: '830:#of_terms-of-usage',
          anchor: '#of_terms-of-usage',
          pos: 'bottom',
          title: 'Условия доступа',
          text: '<p>Вы самостоятельно определяете условия доступа к цифровому объекту авторского права, выбирая один из четырех типов лицензий: <span class="tur_link nowrap" data-key="open">IPU-OPEN</span>, <span class="tur_link nowrap" data-key="org">IPU-ORG</span>, <span class="tur_link nowrap" data-key="internal">IPU-INTERNAL</span>, <span class="tur_link nowrap" data-key="closed">IPU-AUTHORS</span>.</p>',
        },
        {
          path: '/object/IPC-RU.IPU.AD.2018-087EJD7J.1',
          offsetY: 0,
          mobileAnchor: '830:.mme_menu',
          anchor: '.ntm_icon.ntm_icon--user',
          pos: 'bottom',
          title: 'Регистрация',
          text: '<p>Зарегистрируйтесь на платформе и защитите авторские права на ваши объекты с помощью депонирования!</p>',
        },
      ],
      popupClass: '',
      title: '',
      text: '',
      cornerClass: '',
      cornerStyle: {},
      showOnRouteChange: false,
      unwatchXhrActiveNum: null,
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.stopTour();
    });
    J(document).on('click', '.tur_link', (e) => {
      const JLink = J(e.currentTarget);
      const key = JLink.data('key');
      this.dialogCur.title = this.dialogAll[key].title;
      this.dialogCur.markup = this.dialogAll[key].markup;
      this.usageConditionsVisible = true;
    });
    // J(document).click(this.stopTour);
    this.$watch('$store.state.tourState', this.startTour);
  },
  watch: {
    $route() {
      if (!this.showOnRouteChange) {
        this.stopTour();
      }
    },
  },
  computed: {
    dialogAll() {
      const types = this.$store.getters['types/getTypes'];
      const type = types[0];
      const licensesOptions = type.Fields.find(el => el.Name === 'Licenses');
      const content = {};
      Object.keys(this.licenses).forEach((key) => {
        const description = licensesOptions.WidgetOptions.OptionsDescriptions[key];
        // const title = licensesOptions.WidgetOptions.Options[key];
        content[key] = {};
        content[key].title = 'Условия доступа';
        content[key].markup = `<div class="licenses_lic">
            <img src="${this.licenses[key].icon}" class="lic_icon">
            <h2 class="lic_title">${licensesOptions.WidgetOptions.Options[key]}</h2>
            <p class="lic_desc">${description}</p>
          </div>
          <p><span style="display: block; color: #000; font-weight: 500;">
            Доступ к цифровому объекту:</span>
            Бесплатно с учетом лицензионных ограничений.</p>
        `;
      });
      return content;
    },
  },
  methods: {
    gotoStep(stepIndex) {
      const step = this.steps[stepIndex];
      this.showOnRouteChange = true;
      this.$router.push({ path: step.path });
      this.$nextTick(() => {
        setTimeout(() => this.renderStep(stepIndex), 100);
      });
    },
    renderStep(stepIndex) {
      this.isVisible = false;
      if (this.$store.state.xhrActiveNum > 0) {
        if (!this.unwatchXhrActiveNum) {
          this.unwatchXhrActiveNum = this.$watch('$store.state.xhrActiveNum', () => {
            this.$nextTick(() => {
              setTimeout(() => this.renderStep(stepIndex), 100);
            });
          });
        }
        return;
      }
      if (this.unwatchXhrActiveNum) {
        this.unwatchXhrActiveNum();
        this.unwatchXhrActiveNum = null;
      }
      this.isVisible = true;
      this.showOnRouteChange = false;
      const step = this.steps[stepIndex];
      const JEl = J('.tur_win');
      const popupWidth = JEl.outerWidth();
      const popupHeight = JEl.outerHeight();
      const winWidth = J(window).width();
      const popupOffsetVert = 15;
      const popupWinMargin = 25;
      this.title = step.title;
      this.text = step.text;

      let JAnchor;
      if (step.mobileAnchor) {
        const ma = step.mobileAnchor;
        const maArr = ma.split(':');
        const bp = parseInt(maArr[0], 10);
        if (bp > winWidth) {
          JAnchor = J(maArr[1]);
        }
      }
      if (!JAnchor) {
        JAnchor = J(step.anchor);
      }
      if (!JAnchor) {
        return;
      }

      let top = 0;
      let left = 0;
      let topStart = 0;
      this.popupClass = {};
      this.popupClass[`tur--${step.pos}`] = true;
      const anchorCenterLeft = JAnchor.offset().left + (JAnchor.outerWidth() / 2);
      switch (step.pos) {
        case 'top':
          top = (JAnchor.offset().top - popupHeight - popupOffsetVert) + step.offsetY;
          topStart = -15;
          this.cornerClass = 'tur_corner-bottom';
          break;
        case 'bottom':
          top = JAnchor.offset().top + JAnchor.outerHeight() + popupOffsetVert + step.offsetY;
          topStart = 15;
          this.cornerClass = 'tur_corner-top';
          break;
        case 'middle-top':
          top = (JAnchor.offset().top - popupHeight - popupOffsetVert)
            + (JAnchor.height() / 2) + step.offsetY;
          topStart = -15;
          this.cornerClass = 'tur_corner-bottom';
          break;
      }
      left = anchorCenterLeft - (popupWidth / 2);
      // If goes away from left of the screen
      if (left < popupWinMargin) {
        left = popupWinMargin;
        this.popupClass['tur--bottom-left'] = true;
      }
      // If goes away from right of the screen
      if (winWidth - left - popupWinMargin < popupWidth) {
        left = winWidth - popupWinMargin - popupWidth;
        this.popupClass['tur--bottom-right'] = true;
      }
      this.cornerStyle.left = `${anchorCenterLeft - left}px`;
      TweenMax.fromTo('.tur_win', 0.3,
        { top: top + topStart, left, opacity: 0 },
        { top, left, opacity: 1, ease: Power1.easeInOut });
    },
    startTour() {
      this.$store.commit('setTourState', 0);
      this.curStep = 0;
      this.$nextTick(() => this.gotoStep(this.curStep));
    },
    stopTour() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/common/main";

$tur_bp: 500px;

.tur_win {
  color: #000;
  position: absolute;
  z-index: 999;
  width: 470px;
  padding: 25px 30px;
  border-radius: 12px;
  background: #fff;
  @include box-shadow(0 2px 30px rgba(0, 0, 0, .2));
  @media (max-width: $tur_bp) {
    width: 280px;
    padding: 15px 20px;
  }
  .tur_corner-top {
    width: 0;
    height: 0;
    position: absolute;
    top: -10px;
    left: 50%;
    margin-left: -7px;
    border-style: solid;
    border-width: 0 7.5px 10px 7.5px;
    border-color: transparent transparent #fff transparent;
  }
  .tur_corner-bottom {
    width: 0;
    height: 0;
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -7px;
    border-style: solid;
    border-width: 10px 7.5px 0 7.5px;
    border-color: #ffffff transparent transparent transparent;
  }
  .tur_close {
    font-size: 24px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    opacity: .7;
    @include transition;
    &:hover {
      opacity: 1;
    }
  }
  .tur_title {
    font-weight: 700;
    margin-bottom: 15px;
    padding-right: 20px;
  }
  .tur_title-step {
    font-weight: 400;
    padding: 1px 5px 0;
    @include border-radius(6px);
    background: #999;
    color: #fff;
    font-size: 11px;
    vertical-align: top;
    margin-top: 3px;
    display: inline-block;
    margin-right: 5px;
  }
  .tur_text {
    color: #333;
    p {
      margin: 0 0 10px;
      line-height: 23px;
    }
  }
  .tur_link {
    color: $color-2;
    @include transition;
    cursor: pointer;
    &:hover {
      color: $color-1;
    }
    &.nowrap {
      white-space: nowrap;
    }
  }
  .tur_nav {
    text-align: right;
    margin: 20px -5px 0;
    @media (max-width: $tur_bp) {
      text-align: center;
    }
    .tur_nav-btn {
      border: 1px solid #da5486;
      color: #da5486;
      margin: 0 3px;
      width: 80px;
      display: inline-block;
      text-align: center;
      border-radius: 20px;
      cursor: pointer;
      line-height: 0;
      padding: 15px 0;
      @include transition;
      &:hover {
        color: #fff;
        @extend .grad;
        border-color: transparent;
      }
      &.tur_nav-btn-xl {
        width: 150px;
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tour.vue